// extracted by mini-css-extract-plugin
export var container = "_sk-0";
export var inputWidth = "_sk-1";